import moment from "moment";

export default {
    ErrorGeneric: "An error occurred. Please try again.",
    ErrorFieldRequired: "This field is required.",
    ErrorEmailInvalid: "Please enter a valid email.",
    ErrorMobileInvalid: "Please enter a valid mobile number.",
    ErrorTandCsRequired: "Please accept the Terms & Conditions to continue.",
    ErrorLoadingLocations: "Error loading locations. Please try again.",
    ErrorLoadingMenu: "Error loading menu. Please try again.",
    /* ⚠ Says what to DO, and never where to look.
       Was "Please fix the above errors." until 19 Oct 2026. Two problems with it: the summary
       panel that shows it sits to the RIGHT of the fields at checkout, not below them, so "above"
       was simply wrong; and it told the customer nothing they could act on. Position belongs in
       the layout, not in the words - a message that names a direction is wrong the moment the
       page reflows on a phone.
       This is the LAST-RESORT wording, used when more than one thing is wrong. Where the caller
       knows exactly what is missing it should say that instead - see the checkout summary in
       App.js, which names the single problem when there is only one. */
    ErrorProductForm: "Please check the highlighted fields and try again.",
    ErrorSpecialCharName: "The above can only contain letters, numbers, and special characters ( ) - , . ' ! $ %",
    // Offline
    ErrorStoreClosedWeb: "Store is currently not accepting orders.",
    ErrorStoreClosedTable: "Please go to the counter to place your order.",
    // Location
    /* ⚠ KEPT, and still used — but only for the two cases where clearing the
       basket really is the whole answer: when the new store's menu could not be
       read (so we cannot promise what survives) and when nothing in the basket
       is sold there. The ordinary case now reports what changed instead.
       See Cart Location Change in S8MC Specs. */
    LocationWarnChange: <div>Changing the location will <span className="text-danger">clear out your cart</span>, are you sure you want to clear it and choose another location?</div>,
    // --- Cart migration on a store change ---
    CartMigrationChecking: "Checking what's available at this store…",
    CartMigrationNoChange: "Everything in your basket is available at this store.",
    CartMigrationAllRemoved: <div>None of your basket is sold at this store. Changing will <span className="text-danger">empty it</span>.</div>,
    CartMigrationRemovedHead: "Not sold at this store — these will be removed",
    CartMigrationSoldOutHead: "Not available right now — these will be removed",
    CartMigrationRepricedHead: "The price is different at this store",
    CartMigrationKeptTail: "Everything else stays in your basket.",
    // Q2, 8 Oct: a voucher is dropped on a store change, and the customer is told.
    CartMigrationVoucher: "Your voucher will be removed — you can apply it again at the new store.",
    /* FR-08. A partial failure must name what did not make it — a basket that is
       quietly short is worse than an error. */
    CartMigrationPartial: (names) =>
        `These could not be moved to the new store and are not in your basket: ${names.join(', ')}. Please add them again.`,
    // Voucher code in cart (2026-10-14). Every refusal after this comes from the server.
    VoucherCodePrompt: "Have a voucher code?",
    VoucherCodeLabel: "Voucher code",
    VoucherCodeApply: "Apply",
    VoucherCodeEmpty: "Please enter a code.",
    VoucherLabel: "Voucher",
    LocationClosed: "This store is currently closed, please try again later.",
    // Table Number
    ErrorTableNumberInvalid: "Invalid table number.",
    // Product Selection
    ErrorSelectAProduct: "Please select a product to continue.",
    // Delivery
    ErrorDeliveryUnavailable: "Delivery is currently unavailable.",
    ErrorFieldErrors: "Some fields have errors, please confirm the above fields.",
    MethodWarnChange: <div>Changing your order type will <span className="text-danger">clear out your cart</span>, are you sure you want to clear it and start your order again?</div>,
    // Vouchers
    ErrorRedeemVoucherInStore: "To redeem this voucher, scan your card in-store.",
    ErrorVoucherInUse: "A voucher is currently in use.",
    ErrorVoucherIsInCart: "A voucher is already in your cart, please remove this before selecting another voucher.",
    // Calendar
    /* Shown both under the time picker and, when it is the only thing missing, in the order
       summary. "This field is required." was accurate and useless: a day/daypart/time picker is
       not a field, and the customer has usually chosen two of the three.
       ⚠ Deliberately NOT "pickup time" - the same calendar validation runs for delivery orders
       when DoorDash white-label delivery is off, so naming pickup would be wrong half the time. */
    ErrorNoTimeSelected: "Please choose when you would like your order.",
    ErrorSelectTimeInStoreOpeningHours: "Please select a time within the store's opening hours.",
    CateringCutoffPassed: (cutoffTime) => `Online orders for tomorrow's pickup close at ${moment(cutoffTime, 'HH:mm').format('h:mm A')} each day. Please call your local venue directly to place an order for pickup tomorrow.`
    // Pickup lead time - commented out 2026-10-01, customer did not want the feature.
    //,PickupLeadTimeDateCleared: "An item in your cart needs more notice than the date you selected. Please choose a new pickup date."
    //,PickupLeadTimeDateTooEarly: "An item in your cart needs more notice than the date you selected. Please choose a later pickup date."
}